<template>
  <div class="rank-header-container">
    <!-- 背景 -->
    <img
      class="background-img"
      src="../../../assets/bjnum-rank-banner-bg2.png"
      alt="background"
    />
    <!-- 标题 -->
    <div class="title-container-class">
      <img
        class="arrow-img"
        src="../../../assets/bjnum-topLine-right.png"
        alt="arrow"
      />
      <span class="title-class">每周人气榜</span>
      <img
        class="arrow-img"
        src="../../../assets/bjnum-topLine-left.png"
        alt="arrow"
      />
    </div>
    <!-- 冠亚季军 -->
    <rank-header-item
      :article="this.masterList[0]"
      :rank="1"
      class="avater first-class"
    ></rank-header-item>

    <rank-header-item
      :article="this.masterList[1]"
      :rank="2"
      class="avater second-class"
    ></rank-header-item>

    <rank-header-item
      :article="this.masterList[2]"
      :rank="3"
      class="avater third-class"
    ></rank-header-item>

    <!-- 按钮 -->
    <!-- <van-button class="check-class" plain hairline round color="#ffffff" type="info">查看完整榜单</van-button> -->

    <!-- 期数显示 -->
    <img
      class="history-bg"
      src="../../../assets/bjnum-rank-history-select.png"
      alt="background"
    />
    <span class="history-label">{{ this.historyWord }}</span>
  </div>
</template>

<script>
import RankHeaderItem from '@/views/Rank/components/rank-header-item'
// import { monthAndDay } from '@/utils/dayjs'

export default {
  name: 'RankHeader',
  components: {
    RankHeaderItem
  },
  props: {
    masterList: {
      type: Array,
      required: true
    },
    historyWord: {
      type: String,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
}
</script>

<style lang="less" scoped>
.rank-header-container {
  width: 375px;
  height: 212px;
  position: relative;
  display: flex;
  justify-content: center;
  // text-align: center;
  .background-img {
    display: block;
    width: 375px;
    height: 212px;
  }

  .title-container-class {
    position: absolute;
    top: 5px;
    width: 60%;
    left: 20%;
    height: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .arrow-img {
      display: block;
      width: 50px;
      height: 5px;
    }
    .title-class {
      width: 95px;
      line-height: 18px;
      height: 18px;
      text-align: center;
      color: white;
      font-size: 16px;
    }
  }

  // .check-class{
  //   position: absolute;
  //   bottom: 10px;
  //   height: 20px;
  //   width: 103px;
  //   font-size: 9px;
  //   background-color: transparent;
  // }
  .history-bg {
    position: absolute;
    bottom: 0px;
    height: 36px;
    left: 0px;
    right: 0px;
  }
  .history-label {
    position: absolute;
    bottom: 0px;
    left: 50px;
    width: 275px;
    line-height: 36px;
    height: 36px;
    text-align: center;
    color: #863d2d;
    font-size: 14px;
  }

  .first-class {
    position: absolute;
    top: 26px;
    left: 125px;
  }

  .second-class {
    position: absolute;
    top: 40px;
    left: 7px;
  }

  .third-class {
    position: absolute;
    top: 44px;
    left: 243px;
  }
}
</style>
